// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"suppliers-with-pagination_wrapper__Y1Ie3","info":"suppliers-with-pagination_info__qGiFW","buttonWrapper":"suppliers-with-pagination_buttonWrapper__jahW1"};